<template>
  <div>
    <section class="masthead masthead--inner" style="margin-bottom: 0px;">
      <div class="in">
        <div class="masthead__slide" style="background: rgba(0, 0, 0, 0) url(&quot;../../../../../../static/styles/mailkit/img/banner.jpg&quot;) no-repeat scroll center center / cover; width: 100%; display: inline-block;">
          <div class="masthead__caption">
            <h3 style="text-transform: capitalize;">retrieve your quote</h3>
          </div>
        </div>
      </div>
    </section>
    <h1 v-if="!quotes || quotes.length <= 0">To retrieve, progress or amend your quote enter the unique quote ID we emailed you below</h1>
    <div class="dashboard-form" v-if="!quotes || quotes.length <= 0">
      <div>
        <div class="form-row">
          <input id="Quoteid" type="text" v-model="quote_uniqid" placeholder="Quote id" class="form-input" required style="margin:0 auto">
        </div>
        <div class="form-row">
          <input id="EmailToGetQuote" type="email" v-model="quote_email" placeholder="Email" class="form-input" required style="margin:0 auto">
        </div>
        <div class="form-row">
          <button @click="getQuotes()" class="form-button">retrieve quote</button>
        </div>
        <div v-if="quotes && quotes.length <= 0" class="retrieve-quote-error">
          <span>No quotes found.<br>Please check the quote ID and email address are correct.</span>
        </div>
      </div>
    </div>

    <div v-if="quotes && quotes.length > 0" style="background-color: #E7E6E6">
        <div style="text-align: center; font-size: 24px; color: #0170C0; background-color: white; padding: 6px 14px;">
            <h5 style="margin: 42px 8px">Progress your quote or update your personal details and contact preferences</h5>
        </div>

        <table id="quotes-table">
            <caption style="font-weight: bold; font-size: 18px;padding: 20px 0px;text-align: left;">Your quote details:</caption>
            <tbody>
                <tr>
                    <td class="label">ID:</td>
                    <td class="value">{{ sortedQuotes[0] ? sortedQuotes[0].uniqid : null }}</td>
                </tr>
                <tr>
                    <td class="label">Company name:</td>
                    <td class="value">{{ sortedQuotes[0].user ? sortedQuotes[0].user.company_name : null }}</td>
                </tr>

                <tr>
                    <td class="label">Office address:</td>
                    <td class="value">{{ sortedQuotes[0].office_address }}</td>
                </tr>
                <tr>
                    <td class="label">Office postcode:</td>
                    <td class="cell-postcode value">{{ sortedQuotes[0].office_postcode }}</td>
                </tr>
                <tr>
                    <td class="label">Updated at:</td>
                    <td class="value">{{ sortedQuotes[0].updated_at }}</td>
                </tr>
                <tr>
                    <td class="label">Created at:</td>
                    <td class="value">{{ sortedQuotes[0].created_at }}</td>
                </tr>
                <tr>
                    <td class="label"></td>
                    <td>
                        <a href="#" @click="loadQuote(sortedQuotes[0].id, 1)" class="btn btn-gradient">Amend Quote</a>
                    </td>
                </tr>
                <tr>
                    <td class="label"></td>
                    <td>
                        <router-link tag="a" :to="{name: 'results.index', params: {quote_id: sortedQuotes[0].uniqid}}" v-if="sortedQuotes[0].step3 || (sortedQuotes[0].step2 && !sortedQuotes[0].uses_franking_machine)" class="btn btn-gradient">View Results</router-link>
                        <span style="color:grey;" v-else class="btn btn-gradient">View Results</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="quotes && quotes.length > 0">
        <div class="quoteSeparator" style="background: linear-gradient(45deg,#0a70e3,#f81e8c);height: 5px;margin: 5px 0px;"></div>
        <table id="details-table">
            <caption style="font-weight: bold; font-size: 18px;padding: 20px 0px;text-align: left;">Your personal details:</caption>
            <tbody>
                <tr>
                    <td class="label">Name:</td>
                    <td class="value">{{ sortedQuotes[0].user ? sortedQuotes[0].user.name : null }}</td>
                </tr>
                <tr>
                    <td class="label">Email:</td>
                    <td class="value">{{ sortedQuotes[0].user ? sortedQuotes[0].user.email : null }}</td>
                </tr>
                <tr>
                    <td class="label">Contact phone:</td>
                    <td class="value">{{ sortedQuotes[0].user ? sortedQuotes[0].user.contact_phone : null }}</td>
                </tr>
                <tr>
                    <td class="label">Preferences:</td>
                    <td class="value">
                        <span v-html="sortedQuotes[0].user.preferences && sortedQuotes[0].user.preferences.preferences_email ? '- email <br>' : null "></span>
                        <span v-html="sortedQuotes[0].user.preferences && sortedQuotes[0].user.preferences.preferences_mail ? '- mail <br>' : null "></span>
                        <span v-html="sortedQuotes[0].user.preferences && sortedQuotes[0].user.preferences.preferences_phone ? '- phone <br>' : null "></span>
                        <span v-html="sortedQuotes[0].user.preferences && sortedQuotes[0].user.preferences.preferences_sms ? '- sms <br>' : null "></span>
                    </td>
                </tr>
                <tr>
                    <td class="label"></td>
                    <td>
                        <a href="#" @click="loadQuote(sortedQuotes[0].id, 2)" v-if="sortedQuotes[0].step2" class="btn btn-gradient">Edit contact details and preferences</a>
                        <span style="color:grey;" v-if="!sortedQuotes[0].step2">Edit contact details andpreferences</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!--------
    <div class="dashboard-table-wrapper" v-if="quotes && quotes.length > 0">
      <div>
        <table id="quotes-table" class="dashboard-table">
          <thead>
          <tr>
            <th @click="sort('id')">
              ID
              <i v-if="currentSort === 'id' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'id' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('user.name')">
              Name
              <i v-if="currentSort === 'user.name' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'user.name' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('user.email')">
              Email
              <i v-if="currentSort === 'user.email' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'user.email' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('user.company_name')">
              Company name
              <i v-if="currentSort === 'user.company_name' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'user.company_name' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('user.contact_phone')">
              Contact phone
              <i v-if="currentSort === 'user.contact_phone' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'user.contact_phone' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('office_address')">
              Office address
              <i v-if="currentSort === 'office_address' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'office_address' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('office_postcode')">
              Office postcode
              <i v-if="currentSort === 'office_postcode' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'office_postcode' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th>Preferences</th>
            <th @click="sort('updated_at')">
              Updated at
              <i v-if="currentSort === 'updated_at' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'updated_at' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th @click="sort('created_at')">
              Created at
              <i v-if="currentSort === 'created_at' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
              <i v-if="currentSort === 'created_at' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
            </th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="quote in sortedQuotes">
            <td>{{ quote ? quote.id : null }}</td>
            <td>{{ quote.user ? quote.user.name : null }}</td>
            <td>{{ quote.user ? quote.user.email : null }}</td>
            <td>{{ quote.user ? quote.user.company_name : null }}</td>
            <td>{{ quote.user ? quote.user.contact_phone : null }}</td>
            <td>{{ quote.office_address }}</td>
            <td class="cell-postcode">{{ quote.office_postcode }}</td>
            <td>
              <span v-html="quote.user.preferences.preferences_email ? '- email <br>' : null "></span>
              <span v-html="quote.user.preferences.preferences_mail ? '- mail <br>' : null "></span>
              <span v-html="quote.user.preferences.preferences_phone ? '- phone <br>' : null "></span>
              <span v-html="quote.user.preferences.preferences_sms ? '- sms <br>' : null "></span>
            </td>
            <td>{{ quote.updated_at }}</td>
            <td>{{ quote.created_at }}</td>
            <td>
              <a href="#" @click="loadQuote(quote.id, 1)">Step1</a>
            </td>
            <td>
              <a href="#" @click="loadQuote(quote.id, 2)" v-if="quote.step2">Step2</a>
              <span style="color:grey;" v-if="!quote.step2">Step2</span>
            </td>
            <td>
              <a href="#" @click="loadQuote(quote.id, 3)" v-if="quote.step3">Step3</a>
              <span style="color:grey;" v-if="!quote.step3">Step3</span>
            </td>
            <td>
              <router-link tag="a" :to="{name: 'results.index', params: {quote_id: quote.uniqid}}" v-if="quote.step3">Results</router-link>
              <span style="color:grey;" v-if="!quote.step3">Results</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    ------>





    <section class="supportPanel">
        <div class="in container">
            <div class="supportPanel__title">
                <h2 style="font-size:1.7rem">Need help with your quote? Please contact our support team.</h2>
            </div>
            <div class="supportPanel__blocks blocks">
                <div class="in">
                    <div class="blocks__block block">
                        <div class="in">
                            <h5>LIVE CHAT</h5>
                            <div class="blockImg">
                                <img src="https://themailingexpert.com/wp-content/themes/ctmk/assets/img/livechat.png">
                            </div>
                            <p>Our Live chat is available from 9am - 5.30 pm </p>
                        </div>
                    </div>
                    <a class="blocks__block block" href="tel:+13300947497">
                        <div class="in">
                            <h5>CALL OUR SUPPORT TEAM </h5>
                            <div class="blockImg">
                                <img src="https://themailingexpert.com/wp-content/themes/ctmk/assets/img/call.png">
                            </div>
                            <p>Call US On: 0330 124 1977</p>
                        </div>
                    </a>
                    <a class="blocks__block block" href="mailto:customerservices@themailingexpert.com">
                        <div class="in">
                            <h5>E MAIL US</h5>
                            <div class="blockImg">
                                <img src="https://themailingexpert.com/wp-content/themes/ctmk/assets/img/email.png">
                            </div>
                            <p>Email Us: <a href="mailto:customerservvices@themailingexpert.com">customerservices@themailingexpert.com</a> </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        quote_uniqid: null,
        quotes: null,
        currentSort: 'id',
        currentSortDir: 'desc',
        quote_email: null,
      }
    },
    methods: {
      getQuotes() {
        if (!this.quote_uniqid || !this.quote_email) return null
        this.axios.get('/quotes', {params: {quote_uniqid: this.quote_uniqid, quote_email: this.quote_email}}).then(response => {
          this.quotes = response.data || [];
          if (this.quotes.length > 0) {
            //document.body.classList.add('has-table');
            //document.getElementsByClassName('dashboard-form')[0].style.display = 'none';
          }
        })
      },
      sort: function (s) {
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = s;
      },
      loadQuote(quote_id, step) {
        this.$store.dispatch('QuoteForm/loadQuoteInStep', {quote_id, step}).then(() => {
          this.$router.push({name: 'quotes.create', query: {dont_reset: true, scroll_bottom: true}})
        })
      }
    },
    computed: {
      base_url() {
        return process.env.BASE_URL
      },
      sortedQuotes: function () {
        return this.quotes.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === 'desc') modifier = -1;
          var index = this.currentSort.split('.')
          if (index.length == 1) {
            if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          } else {
            if (a[index[0]][index[1]] < b[index[0]][index[1]]) return -1 * modifier;
            if (a[index[0]][index[1]] > b[index[0]][index[1]]) return 1 * modifier;
          }
          return 0;
        });
      },
    }
  }
</script>
<style scoped lang="scss">
  .masthead--inner{
    margin-bottom:80px;
  }

  .retrieve-quote-error{
    margin-top:30px;
    border: .625rem solid #D55051;
    background: #E87B7B;
    padding: 2.1875rem;
    color: #fff;
    font-size: 1.125rem;
    font-weight: 700;
    position: relative;
    span{
      position: relative;
      line-height:1.4;
      padding-left:4.7rem;
      display:block
    }
    span:before {
        background: url(/static/img/warning.7635896.png) !important;
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform:translateY(-50%);
        width: 3.875rem;
        height: 3.875rem;
        background-size: contain;
    }
  }



  #quotes-table {
    margin: 0px auto;
    width: 50%;
    @media screen and (max-width: 900px) {
      width: 90%;
    }
    border-collapse: separate;
    border-spacing: 5px;

    TD {
        text-align: left;
        font-size: 1.4rem;
        padding: 10px 0px;

        &.value {
            background-color: #F2F2F2;
            padding-left: 5px;
        }
        &.label {
            width: 150px;
        }
    }
  }

  .quoteSeparator {
    background: linear-gradient(45deg,#0a70e3,#f81e8c);
    height: 5px;
    margin: 5px 0px;
  }

  #details-table {
    margin: 0px auto;
    width: 50%;
    @media screen and (max-width: 900px) {
      width: 90%;
    }
    border-collapse: separate;
    border-spacing: 5px;

    TD {
        text-align: left;
        font-size: 18px;
        padding: 10px 0px;

        &.value {
            border: 1px solid #F2F2F2;
            padding-left: 5px;
        }
        &.label {
            width: 150px;
        }
    }
  }

  h1 {
    margin: 0 auto;
    padding: 30px 30px 0 30px;
    max-width: 800px;
    text-align: center;
    font-size: 1.8rem;
    margin-bottom: 10px;
    line-height: 1.2em;
    color: #0a70e3;
  }

  .dashboard-form {
    margin-top: 50px;
    margin-bottom: 80px;
    height: auto;

    .form-input{
      background: #f3f2f2;
      border: none;
      text-align: center;
      color:#363636;
    }

    .form-input::placeholder {
      color:#363636;
      opacity: 1;
    }

    .form-input:-ms-input-placeholder {
      color:#363636;
    }

    .form-input::-ms-input-placeholder {
      color:#363636;
    }

    .form-button{
      background: linear-gradient(45deg,#0a70e3,#f81e8c);
      color: #fff;
      width: auto !important;
      border-radius: 0;
      cursor: pointer;
      border-radius: .3125rem;
      font-size: 1.65625rem;
      padding: 1.25rem 2.6rem;
      text-align: center !important;
      box-shadow: 0 4px 22.56px 1.44px rgba(0,0,0,.3) !important;
      text-transform: capitalize;
      margin: 0 auto;
      height: auto;
    }
  }
  .dashboard-table-wrapper {
    margin-top: 100px;
    margin-bottom: 150px;
    overflow-x: visible;

    @media (max-width: 74.9375em) {
      margin-bottom: 50px;
      overflow-x: scroll;
    }

    > div {
      height: auto;
      overflow: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Quotes/Retrieve.vue